import { useState, useEffect, useCallback } from "react";

const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxlu1iLpbFoTe-5M6VjBz3hgKTlQ1gj4TRGy1tjbwwDprCf0ofUEWHsp-k7pG8yDHLyoQ/exech";

const C = {
  primary: "#1a3a5c", border: "#d4c99a", success: "#2d6a4f",
  danger: "#c1121f", warning: "#e76f51", muted: "#6b7280",
  bg: "#fdfcf8", surface: "#f5f1e8",
};

const urduStyle = { fontFamily:"'Noto Nastaliq Urdu',serif", direction:"rtl", fontSize:"10px", opacity:0.8, display:"inline" };
const AVATAR_COLORS = ["#1a3a5c","#2d6a4f","#1d6fa5","#6b3a5c","#5c4a1a","#3a5c1a"];
const avatarColor = (n) => AVATAR_COLORS[(n||"A").charCodeAt(0) % AVATAR_COLORS.length];
const initials = (n) => (n||"?").split(" ").map(w=>w[0]).join("").toUpperCase().slice(0,2);

// Scores from BOTH possible field name formats
const getScore = (r, field, altField) => {
  const v = r[field] ?? r[altField] ?? 0;
  return Number(v) || 0;
};

const calcTotal = (r) =>
  getScore(r,"s2","attendanceScore") +
  getScore(r,"s3","productivityScore") +
  getScore(r,"s4","reportingScore") +
  getScore(r,"s5","problemSolvingScore") +
  getScore(r,"s6","ehsScore") +
  getScore(r,"s7","supervisorScore");

function calcOutcome(r) {
  const t = calcTotal(r);
  if (r.ehs==="major")       return {label:"Immediate Action",ur:"فوری کارروائی",  color:C.danger, bg:"#fde8e8",stars:0};
  if (r.ehs==="complaints2") return {label:"Promo Blocked",   ur:"ترقی روک دی گئی",color:C.warning,bg:"#fdf0e8",stars:0};
  if (t>=90) return {label:"Excellent",ur:"بہترین",color:C.success, bg:"#e8f5e9",stars:3};
  if (t>=80) return {label:"Good",     ur:"اچھا",  color:"#1d6fa5", bg:"#e8f0f5",stars:2};
  return           {label:"Average",   ur:"اوسط",  color:C.warning, bg:"#fdf0e8",stars:1};
}

function Spinner({msg}) {
  return (
    <div style={{textAlign:"center",padding:"60px 20px"}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{width:"38px",height:"38px",border:`3px solid ${C.border}`,borderTop:`3px solid ${C.primary}`,borderRadius:"50%",margin:"0 auto 14px",animation:"spin .8s linear infinite"}}/>
      <div style={{fontSize:"13px",color:C.muted}}>{msg}</div>
    </div>
  );
}

function ErrorBox({message,onRetry}) {
  return (
    <div style={{background:"#fde8e8",border:`1px solid ${C.danger}`,borderRadius:"8px",padding:"20px",textAlign:"center",margin:"20px 0"}}>
      <div style={{fontSize:"13px",color:C.danger,fontWeight:"bold",marginBottom:"8px"}}>Data load karne mein masla aaya</div>
      <div style={{fontSize:"11px",color:C.muted,marginBottom:"14px",whiteSpace:"pre-wrap"}}>{message}</div>
      <button onClick={onRetry} style={{background:C.primary,color:"#fff",border:"none",borderRadius:"6px",padding:"8px 20px",fontSize:"12px",fontWeight:"bold",cursor:"pointer"}}>
        Dobara Try Karein
      </button>
    </div>
  );
}

function StatCard({value,label,loading}) {
  return (
    <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:"8px",padding:"12px 14px",textAlign:"center"}}>
      <div style={{fontSize:"22px",fontWeight:"bold",color:loading?C.muted:C.primary}}>{loading?"...":value}</div>
      <div style={{fontSize:"11px",color:C.muted,marginTop:"3px"}}>{label}</div>
    </div>
  );
}

function Avatar({name,size=42,fsize=13}) {
  return (
    <div style={{width:size,height:size,borderRadius:"50%",background:avatarColor(name),color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:"bold",fontSize:fsize,flexShrink:0}}>
      {initials(name)}
    </div>
  );
}

function SupervisorCard({sup,onClick}) {
  const avgClr = sup.avg>=90?C.success:sup.avg>=80?"#1d6fa5":C.warning;
  const [hov,setHov] = useState(false);
  return (
    <div onClick={onClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:"#fff",border:`1.5px solid ${hov?C.primary:C.border}`,borderRadius:"10px",padding:"16px",cursor:"pointer",position:"relative",overflow:"hidden",transition:"all .15s",transform:hov?"translateY(-2px)":"none",boxShadow:hov?"0 4px 16px rgba(26,58,92,.12)":"none"}}>
      <div style={{position:"absolute",top:0,left:0,right:0,height:"4px",background:C.primary}}/>
      <div style={{marginBottom:"10px",marginTop:"4px"}}><Avatar name={sup.name} size={46} fsize={15}/></div>
      <div style={{fontSize:"14px",fontWeight:"bold",color:C.primary,marginBottom:"2px"}}>{sup.name}</div>
      <div style={{fontSize:"11px",color:C.muted,marginBottom:"10px"}}>Supervisor <span style={urduStyle}>نگران</span></div>
      <div style={{display:"flex",justifyContent:"space-between",borderTop:`1px solid ${C.border}`,paddingTop:"8px",fontSize:"11px",color:C.muted}}>
        <span>👤 {sup.employees} employees</span>
        <span>📋 {sup.forms} forms</span>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",paddingTop:"4px",fontSize:"11px"}}>
        <span style={{color:avgClr,fontWeight:"bold"}}>Avg: {sup.avg}/100</span>
        <span style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:"12px",padding:"2px 8px",fontSize:"10px",fontWeight:"bold",color:C.primary}}>View →</span>
      </div>
    </div>
  );
}

function EmployeeCard({emp,onClick}) {
  const avgClr = emp.avg>=90?C.success:emp.avg>=80?"#1d6fa5":C.warning;
  const [hov,setHov] = useState(false);
  return (
    <div onClick={onClick} onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{background:"#fff",border:`1px solid ${hov?C.primary:C.border}`,borderRadius:"10px",padding:"14px",cursor:"pointer",transition:"all .15s",transform:hov?"translateY(-2px)":"none",boxShadow:hov?"0 3px 12px rgba(26,58,92,.1)":"none"}}>
      <div style={{marginBottom:"8px"}}><Avatar name={emp.name} size={40} fsize={13}/></div>
      <div style={{fontSize:"13px",fontWeight:"bold",color:"#1a1a1a",marginBottom:"2px"}}>{emp.name}</div>
      <div style={{fontSize:"11px",color:C.muted,marginBottom:"8px"}}>{emp.role||"—"} | {emp.site||"—"}</div>
      <div style={{display:"flex",justifyContent:"space-between",borderTop:`1px solid ${C.border}`,paddingTop:"8px",fontSize:"11px",alignItems:"center"}}>
        <span style={{color:C.muted}}>📋 {emp.forms} form(s)</span>
        <span style={{color:avgClr,fontWeight:"bold"}}>Avg {emp.avg}</span>
      </div>
    </div>
  );
}

function FormCard({record}) {
  // Read both possible field name formats
  const s2 = getScore(record,"s2","attendanceScore");
  const s3 = getScore(record,"s3","productivityScore");
  const s4 = getScore(record,"s4","reportingScore");
  const s5 = getScore(record,"s5","problemSolvingScore");
  const s6 = getScore(record,"s6","ehsScore");
  const s7 = getScore(record,"s7","supervisorScore");
  const t  = s2+s3+s4+s5+s6+s7;
  const oc = calcOutcome(record);
  const ehs = record.ehs||record.ehsViolation||"none";
  const ehsLabel = ehs==="none"?"No Violation":ehs==="minor1"?"Minor":ehs==="complaints2"?"2 Complaints":"MAJOR";

  const sections = [
    {label:"Attendance",  val:s2, max:25},
    {label:"Productivity",val:s3, max:25},
    {label:"Reporting",   val:s4, max:25},
    {label:"Problem",     val:s5, max:10},
    {label:"EHS",         val:s6, max:10},
    {label:"Supervisor",  val:s7, max:5},
  ];

  return (
    <div style={{background:"#fff",border:`1px solid ${C.border}`,borderRadius:"10px",overflow:"hidden"}}>
      <div style={{background:C.primary,color:"#fff",padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontSize:"12px",fontWeight:"bold"}}>Week ending: {record.date||"—"}</div>
          <div style={{fontSize:"10px",color:"#a0b8d0"}}>{record.site||"—"} | {record.role||"—"}</div>
        </div>
        <div style={{fontSize:"10px",color:"#a0b8d0"}}>{ehsLabel}</div>
      </div>
      <div style={{padding:"14px"}}>
        <div style={{fontSize:"36px",fontWeight:"bold",textAlign:"center",color:oc.color,marginBottom:"4px"}}>
          {t}<span style={{fontSize:"16px",color:C.muted,fontWeight:"normal"}}>/100</span>
        </div>
        <div style={{textAlign:"center",marginBottom:"10px"}}>
          <span style={{display:"inline-block",background:oc.bg,color:oc.color,fontWeight:"bold",fontSize:"11px",padding:"4px 10px",borderRadius:"12px"}}>
            {oc.label} <span style={urduStyle}>{oc.ur}</span>
          </span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"6px"}}>
          {sections.map(s=>(
            <div key={s.label} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:"6px",padding:"6px",textAlign:"center"}}>
              <div style={{fontSize:"15px",fontWeight:"bold",color:C.primary}}>
                {s.val}<span style={{fontSize:"9px",color:C.muted}}>/{s.max}</span>
              </div>
              <div style={{fontSize:"9px",color:C.muted,marginTop:"1px"}}>{s.label}</div>
            </div>
          ))}
        </div>
        {record.remarks && (
          <div style={{marginTop:"10px",fontSize:"11px",color:C.muted,borderTop:`1px solid ${C.border}`,paddingTop:"8px",fontStyle:"italic"}}>
            "{record.remarks}"
          </div>
        )}
        {oc.stars>0 && <div style={{textAlign:"center",marginTop:"8px",fontSize:"18px"}}>{"⭐".repeat(oc.stars)}</div>}
      </div>
    </div>
  );
}

export default function AdminEmployeeEvaluation() {
  const [db,setDb]               = useState([]);
  const [loading,setLoading]     = useState(true);
  const [error,setError]         = useState(null);
  const [view,setView]           = useState("supervisors");
  const [currentSup,setCurrentSup] = useState(null);
  const [currentEmp,setCurrentEmp] = useState(null);
  const [search,setSearch]       = useState("");
  const [lastRefresh,setLastRefresh] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`${SCRIPT_URL}?action=get&t=${Date.now()}`);
      const json = await res.json();
      if (json.status==="success") {
        const clean = (json.data||[]).filter(r=>r.name&&r.name.toString().trim()!=="");
        setDb(clean);
        setLastRefresh(new Date());
      } else {
        setError(json.message||"Server se error aaya");
      }
    } catch(e) {
      setError("Google Sheets se connect nahi ho saka.\n\nApps Script mein:\n- Execute as: Me\n- Who has access: Anyone\nset karein, phir dobara deploy karein.");
    } finally {
      setLoading(false);
    }
  },[]);

  useEffect(()=>{fetchData();},[fetchData]);

  const getSupervisors = () => {
    const map={};
    db.forEach(r=>{
      const sup=(r.supervisor||"Unknown").toString().trim();
      if(!map[sup]) map[sup]={name:sup,employeeSet:new Set(),forms:0,totalScore:0};
      map[sup].employeeSet.add((r.name||"").toString().trim());
      map[sup].forms++;
      map[sup].totalScore+=calcTotal(r);
    });
    return Object.values(map).map(s=>({...s,employees:s.employeeSet.size,avg:s.forms?Math.round(s.totalScore/s.forms):0}));
  };

  const getEmployees = (sup) => {
    const map={};
    db.filter(r=>(r.supervisor||"").toString().trim()===sup).forEach(r=>{
      const nm=(r.name||"").toString().trim();
      if(!map[nm]) map[nm]={name:nm,id:r.id,role:r.role,site:r.site,forms:0,totalScore:0};
      map[nm].forms++;
      map[nm].totalScore+=calcTotal(r);
    });
    return Object.values(map).map(e=>({...e,avg:e.forms?Math.round(e.totalScore/e.forms):0}));
  };

  const getForms = (sup,emp) =>
    db.filter(r=>(r.supervisor||"").toString().trim()===sup&&(r.name||"").toString().trim()===emp)
      .sort((a,b)=>(b.date||"").localeCompare(a.date||""));

  const allSups = getSupervisors();
  const allEmps = [...new Set(db.map(r=>(r.name||"").toString().trim()).filter(Boolean))];
  const avgScore = db.length?Math.round(db.reduce((a,r)=>a+calcTotal(r),0)/db.length):0;

  const goSupervisors = ()=>{setView("supervisors");setCurrentSup(null);setCurrentEmp(null);setSearch("");};
  const goEmployees   = (sup)=>{setView("employees");setCurrentSup(sup);setCurrentEmp(null);setSearch("");};
  const goForms       = (emp)=>{setView("forms");setCurrentEmp(emp);};

  const renderSupervisors = () => {
    if(loading) return <Spinner msg="Google Sheets se data aa raha hai..."/>;
    if(error)   return <ErrorBox message={error} onRetry={fetchData}/>;
    if(!allSups.length) return (
      <div style={{textAlign:"center",padding:"60px 20px",color:C.muted}}>
        <div style={{fontSize:"48px",marginBottom:"12px"}}>📋</div>
        <div style={{fontSize:"14px",fontWeight:"bold",marginBottom:"6px"}}>Koi data nahi mila</div>
        <div style={{fontSize:"12px"}}>Google Sheets mein koi evaluation record nahi hai abhi tak.</div>
      </div>
    );
    return (
      <>
        <div style={{fontSize:"11px",fontWeight:"bold",color:C.muted,textTransform:"uppercase",letterSpacing:".05em",marginBottom:"10px"}}>
          Supervisors · <span style={urduStyle}>نگران</span> ({allSups.length})
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"14px"}}>
          {allSups.map(s=><SupervisorCard key={s.name} sup={s} onClick={()=>goEmployees(s.name)}/>)}
        </div>
      </>
    );
  };

  const renderEmployees = () => {
    let list=getEmployees(currentSup);
    if(search) list=list.filter(e=>e.name.toLowerCase().includes(search.toLowerCase())||(e.role||"").toLowerCase().includes(search.toLowerCase()));
    return (
      <>
        <button onClick={goSupervisors} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:"6px",padding:"7px 14px",fontSize:"12px",cursor:"pointer",color:C.primary,fontWeight:"bold",marginBottom:"14px"}}>
          ← Back to Supervisors
        </button>
        <div style={{background:C.primary,borderRadius:"10px",padding:"14px 18px",color:"#fff",marginBottom:"12px"}}>
          <div style={{fontSize:"15px",fontWeight:"bold"}}>👤 {currentSup}</div>
          <div style={{fontSize:"11px",color:"#a0b8d0",marginTop:"2px"}}>{list.length} employee(s) · نگران</div>
        </div>
        <input type="text" placeholder="Search employees..." value={search} onChange={e=>setSearch(e.target.value)}
          style={{width:"100%",border:`1.5px solid ${C.border}`,borderRadius:"8px",padding:"9px 14px",fontSize:"13px",outline:"none",background:"#fff",marginBottom:"12px",boxSizing:"border-box"}}/>
        {!list.length
          ? <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}><p style={{fontSize:"13px"}}>Koi employee nahi mila.</p></div>
          : <>
              <div style={{fontSize:"11px",fontWeight:"bold",color:C.muted,textTransform:"uppercase",letterSpacing:".05em",marginBottom:"10px"}}>Employees ({list.length})</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"14px"}}>
                {list.map(e=><EmployeeCard key={e.name} emp={e} onClick={()=>goForms(e.name)}/>)}
              </div>
            </>
        }
      </>
    );
  };

  const renderForms = () => {
    const list=getForms(currentSup,currentEmp);
    return (
      <>
        <button onClick={()=>goEmployees(currentSup)} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:"6px",padding:"7px 14px",fontSize:"12px",cursor:"pointer",color:C.primary,fontWeight:"bold",marginBottom:"14px"}}>
          ← Back to Employees
        </button>
        <div style={{background:C.primary,borderRadius:"10px",padding:"14px 18px",color:"#fff",marginBottom:"12px"}}>
          <div style={{fontSize:"15px",fontWeight:"bold"}}>📋 {currentEmp}</div>
          <div style={{fontSize:"11px",color:"#a0b8d0",marginTop:"2px"}}>{currentSup} · {list.length} weekly evaluation(s)</div>
        </div>
        {!list.length
          ? <div style={{textAlign:"center",padding:"40px 20px",color:C.muted}}><p style={{fontSize:"13px"}}>Is employee ka koi form nahi mila.</p></div>
          : <>
              <div style={{fontSize:"11px",fontWeight:"bold",color:C.muted,textTransform:"uppercase",letterSpacing:".05em",marginBottom:"10px"}}>Weekly Forms ({list.length})</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:"14px"}}>
                {list.map((r,i)=><FormCard key={i} record={r}/>)}
              </div>
            </>
        }
      </>
    );
  };

  // SCROLL FIX: height:100vh + overflowY:auto on outer div
  return (
    <div style={{height:"100vh",overflowY:"auto",background:C.bg,fontFamily:"Georgia,serif",color:"#1a1a1a"}}>
      <div style={{maxWidth:"960px",margin:"0 auto",padding:"16px"}}>

        <div style={{background:C.primary,color:"#fff",borderRadius:"10px 10px 0 0",padding:"16px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"8px"}}>
          <div>
            <div style={{fontSize:"16px",fontWeight:"bold"}}>📋 Employee Evaluation Dashboard</div>
            <div style={{fontSize:"11px",color:"#a0b8d0",marginTop:"2px",fontStyle:"italic"}}>
              Weekly Assessment · <span style={urduStyle}>ہفتہ وار جائزہ</span>
              {lastRefresh&&<span style={{marginLeft:"10px"}}>· Last updated: {lastRefresh.toLocaleTimeString()}</span>}
            </div>
          </div>
          <button onClick={fetchData} disabled={loading}
            style={{background:"#f0c040",color:"#1a1a1a",border:"none",borderRadius:"6px",padding:"8px 16px",fontSize:"12px",fontWeight:"bold",cursor:loading?"not-allowed":"pointer",opacity:loading?0.6:1}}>
            {loading?"Loading...":"🔄 Refresh"}
          </button>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"10px",margin:"12px 0"}}>
          <StatCard value={allSups.length}                   label="Supervisors"  loading={loading}/>
          <StatCard value={allEmps.length}                   label="Employees"    loading={loading}/>
          <StatCard value={db.length}                        label="Total Forms"  loading={loading}/>
          <StatCard value={db.length?avgScore+"%":"—"}       label="Avg Score"    loading={loading}/>
        </div>

        <div style={{display:"flex",alignItems:"center",gap:"6px",fontSize:"12px",color:C.muted,marginBottom:"12px",flexWrap:"wrap"}}>
          <span style={{cursor:"pointer",color:C.primary,textDecoration:"underline"}} onClick={goSupervisors}>🏠 All Supervisors</span>
          {currentSup&&(<>
            <span style={{color:"#ccc"}}>›</span>
            {view==="employees"
              ?<span style={{color:"#1a1a1a",fontWeight:"bold"}}>{currentSup}</span>
              :<span style={{cursor:"pointer",color:C.primary,textDecoration:"underline"}} onClick={()=>goEmployees(currentSup)}>{currentSup}</span>
            }
          </>)}
          {currentEmp&&(<>
            <span style={{color:"#ccc"}}>›</span>
            <span style={{color:"#1a1a1a",fontWeight:"bold"}}>{currentEmp}</span>
          </>)}
        </div>

        {view==="supervisors"&&renderSupervisors()}
        {view==="employees"  &&renderEmployees()}
        {view==="forms"      &&renderForms()}
      </div>
    </div>
  );
}